import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getQuestionsSuccess,
  getQuestionsFail,
  submitFormSuccess,
  submitFormFail
} from '../../reduxModules/formReducer/formActions';
import {
  updateUserDetails
} from '../../reduxModules/userReducer/userActions';
import { getApiCallable, showNotif } from "../../firebaseModules/apiclient";
import { Loader } from "../Loader/Loader";
import Form from "./Form/Form";
import './Qna.css';
import { withRouter } from "react-router";

class Qna extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      boolLoading: false
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      (!this.props.formReducer.submitRes
      || (this.props.formReducer.submitRes && !this.props.formReducer.submitRes.isAllowed))
      && (!!nextProps.formReducer.submitRes)
    ) {
      this.props.history.replace('/');
      // if (nextProps.formReducer.submitRes.isAllowed) {
      //   this.props.history.push("/approved");
      // } else {
      //   this.props.history.push("/rejected");
      // }
    }
  }
  componentDidMount() {
    if (!this.props.formReducer.formData) {
      this.fetchQuestionsData();
    }
  }
  setLoading = (bool) => {
    this.setState({ boolLoading: bool });
  }
  fetchQuestionsData = async () => {
    try {
      this.setLoading(true);
      const getQuestionsCallable = getApiCallable("getQuestions");
      const getQuesRes = await getQuestionsCallable({});
      this.setLoading(false);
      this.props.getQuestionsSuccess(getQuesRes);
    } catch (error) {
      showNotif(error);
      this.setLoading(false);
      this.props.getQuestionsFail();
    }
  }
  handleSubmit = async (data) => {
    try {
      this.setLoading(true);
      const submitFormCallable = getApiCallable("submitForm");
      const submitFormRes = await submitFormCallable(data);

      // Resyncing user details
      const getUserDetailsCallable = getApiCallable("getUserDetails");
      const res = await getUserDetailsCallable();
      this.props.updateUserDetails(res.data);

      this.setLoading(false);
      this.props.submitFormSuccess(submitFormRes);
    } catch (error) {
      showNotif(error);
      this.setLoading(false);
      
      // Resyncing user details
      const getUserDetailsCallable = getApiCallable("getUserDetails");
      const res = await getUserDetailsCallable();
      this.props.updateUserDetails(res.data);
      this.props.submitFormFail();
    }
  }
  render() {
    return (
      <div className="qnaContainer">
        {
          this.state.boolLoading &&
          <Loader />
        }
        <Form
          formData={this.props.formReducer.formData}
          onSubmit={this.handleSubmit}
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    formReducer: state.formReducer
  }),
  (dispatch) => bindActionCreators({
    getQuestionsSuccess,
    getQuestionsFail,
    submitFormSuccess,
    submitFormFail,
    updateUserDetails
  }, dispatch)
)(withRouter(Qna));
